<template>
    <ion-page class="ion-page" id="main">
        <default-header/>

        <ion-content ref="content" fullscreen>
            <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
                <ion-refresher-content></ion-refresher-content>
            </ion-refresher>

            <flash-messages/>

            <messages
                :messages="messages"
                :pagination="$store.getters.inboxMessagesPagination"
                :showSkeleton="showSkeleton"
                :listTitle="$t('ncrypt.inbox.title')"
                type="inbox"
                v-show="!initialized || initialized && hasMessages"
                ref="messages"
                v-on:refresh="refresh($event)"
                v-on:load-data="loadData($event)"
            />

            <div v-show="!busy && !hasMessages">
                <ion-card class="floating">
                    <ion-card-content>
                        <ion-label>{{ $t('ncrypt.inbox.no_messages') }}</ion-label>
                        <br/>
                        <br/>
                        <ion-button @click="$router.push({name: 'writeMessage'})">
                            <ion-icon ios='add-circle' md="add-circle"/>
                            {{ $t('ncrypt.inbox.send_message_button') }}
                        </ion-button>
                    </ion-card-content>
                </ion-card>
            </div>

            <ion-fab-button class="page-action" @click="$router.push({name: 'writeMessage'})">
                <ion-icon ios='add-circle' md="add-circle"/>
            </ion-fab-button>
        </ion-content>
    </ion-page>
</template>
<script>
    import FlashMessages from "../components/ui-elements/FlashMessages";
    import DefaultHeader from "../components/nav/DefaultHeader";
    import Messages from "../components/messages/list/Messages";

    export default {
        components: {Messages, DefaultHeader, FlashMessages},
        data() {
            return {
                busy: true,
                initialized: false,
                messages: this.$store.getters.inboxMessages,
                unwatch: null,
            }
        },
        computed: {
            showSkeleton() {
                return this.busy && ! this.initialized;
            },
            hasMessages() {
                const value = !! (this.messages && this.messages.length);

                if (value) {
                    this.$refs.content.classList.remove("bg-image");
                } else {
                    this.$refs.content.classList.add("bg-image");
                }

                return value;
            },
        },
        methods: {
            async startLoading() {
                this.busy = true;
                this.loader = await this.$ionic.loadingController.create({
                    message: this.$t('ncrypt.loader.refreshing'),
                    duration: 4000,
                });

                await this.loader.present();
            },
            finishLoading() {
                if (this.loader) {
                    this.loader.dismiss();
                    this.loader = null;
                }

                this.busy = false;
            },
            getCurrentPage() {
                return this.$refs.messages.getCurrentPage();
            },
            async refresh(event) {
                this.initialized = false;
                await this.startLoading();

                await this.$store.dispatch('refreshInbox');

                if (typeof event.target.complete === 'function') {
                    event.target.complete();
                }

                this.finishLoading();
                this.initialized = true;
            },
            async loadData(event) {
                if (! this.getCurrentPage() || this.$refs.messages.scrollEndReached || this.busy) {
                    event.target.complete();
                    return;
                }

                this.busy = true;

                await this.$store.dispatch('getInboxMessagesForPage', this.getCurrentPage() + 1);

                this.busy = false;
                event.target.complete();
            },
        },
        async mounted() {
            this.unwatch = this.$store.watch(
                (state, getters) => getters.inboxMessages,
                (newValue) => this.messages = newValue,
            );

            if (! this.messages.length) {
                await this.startLoading();

                await this.$store.dispatch('getInboxMessagesForPage', this.getCurrentPage());

                this.finishLoading();
            }

            this.initialized = true;
        },
        destroyed() {
            this.unwatch();
        },
    }
</script>
